import get from './get';
import update from './update';
export default [get, update];
